<div class="ig-modal event-count-modal">
  <div class="close-button"><mat-icon (click)="close()">clear</mat-icon></div>
  <div class="title">Event Count - {{data.account.userName}}</div>

  <section class="contract-settings">
    <h3>Event contract</h3>
    <label>
      Subscription tier
      <select [(ngModel)]="contract.subscriptionTierId">
        <option value="">Select a tier</option>
        <option *ngFor="let tier of tiers" [value]="tier._id" [disabled]="!tier.isActive">
          {{tier.name}} - {{tier.annualEventLimit | number}} events/year{{tier.isActive ? '' : ' (inactive)'}}
        </option>
      </select>
    </label>
    <label>
      Contract start date (counts from the first day of that month)
      <input type="date" [(ngModel)]="contract.contractStartDate">
    </label>
    <button mat-raised-button color="primary" [disabled]="savingContract" (click)="saveContract()">
      {{savingContract ? 'Saving...' : 'Save contract'}}
    </button>
  </section>

  <section class="report-controls">
    <label>
      Reporting period
      <select [(ngModel)]="periodType" (change)="changePeriod()">
        <option value="calendar">Calendar Year</option>
        <option value="contract" [disabled]="!contract.contractStartDate">Contract Year</option>
      </select>
    </label>
    <label *ngIf="count && count.deliveryStatistics">
      Year
      <select [(ngModel)]="selectedYear" (change)="changeYear()">
        <option *ngFor="let year of count.deliveryStatistics.availableYears" [value]="year">{{reportingYearLabel(year)}}</option>
      </select>
    </label>
    <button mat-button (click)="loadCount(selectedYear)">Refresh</button>
  </section>

  <ig-spinner *ngIf="loading"></ig-spinner>
  <div class="error" *ngIf="error">{{error}}</div>

  <div *ngIf="count && count.deliveryStatistics" class="report-body">
    <section class="summary-grid">
      <div><span>Delivered in {{count.deliveryStatistics.period.label}}</span><strong>{{count.deliveryStatistics.totals.total | number}}</strong></div>
      <div><span>Annual limit</span><strong>{{count.deliveryStatistics.contract.annualEventLimit ? (count.deliveryStatistics.contract.annualEventLimit | number) : 'Not set'}}</strong></div>
    </section>

    <section *ngIf="count.deliveryStatistics.contract.annualEventLimit" class="usage">
      <div class="usage-heading">
        <b>Contract usage: {{count.deliveryStatistics.contract.percentage}}%</b>
        <span>{{count.deliveryStatistics.totals.total | number}} / {{count.deliveryStatistics.contract.annualEventLimit | number}}</span>
      </div>
      <mat-progress-bar mode="determinate" [value]="count.deliveryStatistics.contract.percentage > 100 ? 100 : count.deliveryStatistics.contract.percentage"></mat-progress-bar>
      <div class="alert-status">70% alert: {{alertStatus(70)}} &middot; 100% alert: {{alertStatus(100)}}</div>
    </section>

    <section>
      <h3>Delivered events by source</h3>
      <table>
        <thead><tr><th>Source</th><th>Delivered events</th></tr></thead>
        <tbody>
          <tr *ngFor="let key of sourceKeys">
            <td>{{sourceName(key)}}</td>
            <td>{{count.deliveryStatistics.totals.bySource[key].total | number}}</td>
          </tr>
        </tbody>
      </table>
      <p class="note" *ngIf="count.deliveryStatistics.totals.excluded.duplicates">
        Older monthly records include {{count.deliveryStatistics.totals.excluded.duplicates}} similar events in the source counts; they are excluded from the delivered total.
      </p>
    </section>

    <section>
      <h3>Monthly delivered events</h3>
      <table>
        <thead><tr><th>Month</th><th>Facebook</th><th>Eventbrite</th><th>Serp Google</th><th>AI Aggregator</th><th>Total</th></tr></thead>
        <tbody>
          <tr *ngFor="let month of count.deliveryStatistics.totals.monthly">
            <td>{{month.month}}</td><td>{{month.bySource.facebook}}</td><td>{{month.bySource.eventbrite}}</td>
            <td>{{month.bySource.serpGoogle}}</td><td>{{month.bySource.aiAggregator}}</td><td><b>{{month.total}}</b></td>
          </tr>
          <tr *ngIf="!count.deliveryStatistics.totals.monthly.length"><td colspan="6">No delivered events in this period.</td></tr>
        </tbody>
      </table>
    </section>

    <section *ngIf="count.aiAggregator">
      <h3>AI Event Aggregator Event Count</h3>
      <p>Current Approved: <b class="approved">{{count.aiAggregator.approved}}</b> &middot; Current Unapproved:
        <b class="unapproved">{{count.aiAggregator.unapproved}}</b></p>
      <p *ngIf="count.aiAggregator.lastRun">Last execution: <b>{{displayRun(count.aiAggregator.lastRun)}}</b> ·
        {{count.aiAggregator.lastRun.status}} · {{duration(count.aiAggregator.lastRun.durationMs)}}</p>
      <table>
        <thead><tr><th>City</th><th>Started</th><th>Completed</th><th>Status</th><th>New</th><th>Existing</th><th>Updated</th><th>Filtered</th><th>Duration</th></tr></thead>
        <tbody>
          <tr *ngFor="let city of count.aiAggregator.cities">
            <td>{{city.latestRun.city}}, {{city.latestRun.state}}</td>
            <td>{{city.latestRun.createdAt | date:'medium'}}</td>
            <td>{{city.latestRun.completedAt ? (city.latestRun.completedAt | date:'medium') : 'N/A'}}</td>
            <td [class.failed]="city.latestRun.status === 'failed'">
              <ng-container *ngIf="city.latestRun.status === 'completed_with_errors'; else regularStatus">
                <span class="completed-with-errors-status">
                  Completed
                  <mat-icon
                    matTooltip="completed_with_errors: The run completed and successful events were processed, but one or more non-fatal issues occurred, usually from partial Batch request failures, image processing failures, or temporary external network/service errors."
                    matTooltipPosition="above"
                    aria-label="Completed with errors information">info_outline</mat-icon>
                </span>
              </ng-container>
              <ng-template #regularStatus>{{city.latestRun.status}}</ng-template>
            </td>
            <td>{{city.latestSuccessfulRun ? city.latestSuccessfulRun.newEvents : 0}}</td>
            <td>{{city.latestSuccessfulRun ? city.latestSuccessfulRun.existingEvents : 0}}</td>
            <td>{{city.latestSuccessfulRun ? city.latestSuccessfulRun.updatedEvents : 0}}</td>
            <td>{{city.latestSuccessfulRun ? city.latestSuccessfulRun.filteredEvents : 0}}</td>
            <td>{{duration(city.latestRun.durationMs)}}</td>
          </tr>
          <tr *ngIf="!count.aiAggregator.cities.length"><td colspan="9">No AI Aggregator runs yet.</td></tr>
        </tbody>
      </table>
      <p class="note">A failed latest run remains visible; delivery counts come from that city's latest successful run.</p>
    </section>

    <section>
      <h3>Current source inventory</h3>
      <div class="source-inventory">
        <span>Facebook: {{count.fbPage.approved}} approved / {{count.fbPage.unapproved}} unapproved</span>
        <span>Eventbrite: {{count.eventbritePage.approved}} approved / {{count.eventbritePage.unapproved}} unapproved</span>
        <span>Serp Google: {{count.serpGoogle.approved}} approved / {{count.serpGoogle.unapproved}} unapproved</span>
        <span>AI Aggregator: {{count.aiAggregator.approved}} approved / {{count.aiAggregator.unapproved}} unapproved</span>
      </div>
      <mat-expansion-panel>
        <mat-expansion-panel-header>Latest source-page runs</mat-expansion-panel-header>
        <h4>Facebook</h4>
        <p *ngFor="let page of count.fbPage.pages">
          {{page.url}} | {{page.lastRunTime ? (page.lastRunTime | date:'medium') : 'N/A'}},
          New: {{page.newEventsPulledInLastRun || 0}}, Existing: {{page.existedEventPulledInLastRun || 0}}
        </p>
        <h4>Eventbrite</h4>
        <p *ngFor="let page of count.eventbritePage.pages">
          {{page.url}} | {{page.lastRunTime ? (page.lastRunTime | date:'medium') : 'N/A'}},
          New: {{page.newEventsPulledInLastRun || 0}}, Existing: {{page.existedEventPulledInLastRun || 0}}
        </p>
        <h4>Serp Google</h4>
        <p *ngFor="let page of count.serpGoogle.pages">
          {{page.url}} | {{page.lastRunTime ? (page.lastRunTime | date:'medium') : 'N/A'}},
          New: {{page.newEventsPulledInLastRun || 0}}, Existing: {{page.existedEventPulledInLastRun || 0}}
        </p>
      </mat-expansion-panel>
    </section>
  </div>
</div>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.count/event.count.modal.component.html